import "./styles/tokens.css";
import "./styles/theme.css";
import "./styles/layout.css";
import "./styles/components.css";
import { FastbootNextApp } from "./app";

customElements.define("fastboot-next-app", FastbootNextApp);
